import React from 'react';
import client1 from '../img/aza-mart.png';
import client2 from '../img/JRPAerospace.png';
import client3 from '../img/saada-mart.png';
import client4 from '../img/CO.png';
import client5 from '../img/hs.png';
import client6 from '../img/fresho.png';

import './clients.css';
const Clients = () => {
  return (
    <section className="clients" id="clients">
      <h2>Our Clients</h2>

      <div className="logo-slider">
        <div className="logo-track">
          {/* First set */}
          <img src={client1} alt="Client" />
          <img src={client2} alt="Client" />
          <img src={client3} alt="Client" />
          <img src={client4} alt="Client" />
          <img src={client5} alt="Client" />
          <img src={client6} alt="Client" />
          

          {/* Duplicate set for infinite loop */}
          <img src={client1} alt="Client" />
          <img src={client2} alt="Client" />
          <img src={client3} alt="Client" />
          <img src={client4} alt="Client" />
          <img src={client5} alt="Client" />
          <img src={client6} alt="Client" />
          
        </div>
      </div>
    </section>
  );
};

export default Clients;
